import { Box, Button, Heading, VStack, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

export default function MainMenu() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const current = JSON.parse(localStorage.getItem("currentUser"));
    setUser(current);
  }, []);

  if (!user)
    return (
      <Box maxW="md" mx="auto" mt={20} textAlign="center">
        <Text>Please login first.</Text>
        <Button mt={4} onClick={() => navigate("/login")} colorScheme="blue">
          Go to Login
        </Button>
      </Box>
    );

  return (
    <Box maxW="md" mx="auto" mt={10} p={6} borderWidth={1} borderRadius="lg">
      <Heading size="lg" mb={6}>
        Main Menu
      </Heading>
      <VStack spacing={4}>
        {user.role === "system-admin" && (
          <>
            <Button
              bgColor="blue.500"
              onClick={() => navigate("/customers")}
              w="full"
            >
              Manage Customers
            </Button>
            <Button
              bgColor="blue.500"
              onClick={() => navigate("/devices")}
              w="full"
            >
              Manage Devices
            </Button>
            <Button
              bgColor="blue.500"
              onClick={() => navigate("/users")}
              w="full"
            >
              Manage Users
            </Button>
          </>
        )}

        {user.role === "admin" && (
          <>
            <Button
              bgColor="blue.500"
              onClick={() => navigate("/devices")}
              w="full"
            >
              Manage Devices
            </Button>
            <Button
              bgColor="blue.500"
              onClick={() => navigate("/users")}
              w="full"
            >
              Manage Users
            </Button>
          </>
        )}

        <Button
          bgColor="teal.500"
          onClick={() => navigate("/console")}
          w="full"
        >
          Dashboard
        </Button>
        <Button
          bgColor="red.500"
          onClick={() => {
            localStorage.removeItem("currentUser");
            localStorage.removeItem("token");
            navigate("/login");
          }}
          w="full"
        >
          Logout
        </Button>
      </VStack>
    </Box>
  );
}